<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">{{ accion }} Hoja de Carga</h5>
              </div>
              <div class="col-md-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Hojas de Carga</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-md-10">
                <div class="card">
                  <div class="card-body">
                    <!-- Cabecera como en la primera foto: logo | HOJA DE CARGA + LOMA JARILLOSA ESTE (2 líneas) | Remito -->
                    <div class="row align-items-center mb-4">
                      <div class="col-md-4">
                        <img
                          src="/img/image.png"
                          alt="Geopark"
                          class="img-fluid"
                          style="
                            max-height: 110px;
                            max-width: 280px;
                            width: auto;
                            height: auto;
                            object-fit: contain;
                          "
                        />
                      </div>
                      <div class="col-md-4 text-center">
                        <h4 class="mb-0 font-weight-bold">HOJA DE CARGA</h4>
                        <h5 class="mb-0 text-muted">
                          {{ form.nombre_isla || "Sin Bloque" }}
                        </h5>
                      </div>
                      <div class="col-md-4">
                        <div
                          class="form-group mb-0 d-flex align-items-center justify-content-end"
                          v-if="accion == 'Editar'"
                        >
                          <label class="mb-0 mr-2">Estado:</label>
                          <span
                            class="w-25 badge"
                            :class="
                              form.estado == 1
                                ? 'bg-success'
                                : form.estado == 2
                                ? 'bg-info'
                                : 'bg-danger'
                            "
                            >{{
                              form.estado == 1
                                ? "Sin Imprimir"
                                : form.estado == 2
                                ? "Imprimido"
                                : "Anulado"
                            }}</span
                          >
                        </div>
                        <div
                          class="form-group mb-0 d-flex align-items-center justify-content-end"
                        >
                          <label class="mb-0 mr-2">Remito:</label>
                          <input
                            type="text"
                            class="form-control form-control-sm w-50"
                            v-model="remito.numero"
                            @change="searchRemito()"
                            placeholder="17-400"
                            :class="[
                              $v.form.remito_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                            :disabled="camposBloqueados"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Dos columnas verticales como el documento impreso (primera foto) -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group row mb-2">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Fecha:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="date"
                              class="form-control form-control-sm"
                              v-model="form.fecha"
                              :class="[
                                $v.form.fecha.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Chofer:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <v-select
                              v-model="chofer"
                              :options="listasForms.choferes"
                              placeholder="Seleccione chofer..."
                              label="nombre"
                              @search="buscarChoferes"
                              @input="selectChofer()"
                              :class="[
                                $v.form.chofer_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                                'form-control-sm form-control p-0 flex-grow-1',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-info py-0 px-1 ml-2"
                              title="Ver datos del chofer (DNI, Nombres y Apellidos)"
                              data-toggle="modal"
                              data-target="#modal-datos-patente"
                              @click="setEntidadModalPatente('Chofer')"
                              :disabled="form.chofer_id"
                            >
                              <i class="fas fa-id-card fa-sm"></i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >DNI:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.numero_chofer"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Camión:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <v-select
                              v-model="camion"
                              :options="listasForms.camiones"
                              placeholder="Seleccione camión..."
                              label="placa"
                              @search="buscarCamiones"
                              @input="selectCamion()"
                              class="form-control form-control-sm p-0 flex-grow-1"
                              :class="[
                                $v.form.camion_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-info py-0 px-1 ml-2"
                              title="Ver datos del camión"
                              data-toggle="modal"
                              data-target="#modal-datos-patente"
                              @click="setEntidadModalPatente('Camión')"
                              :disabled="form.camion_id"
                            >
                              <i class="fas fa-truck fa-sm"></i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >ISLA:</label
                          >
                          <div class="col-sm-8">
                            <v-select
                              v-model="isla"
                              :options="listasForms.islas"
                              placeholder="Seleccione isla..."
                              label="nombre"
                              class="form-control form-control-sm p-0"
                              @search="buscarIslas"
                              @input="selectIsla()"
                              :class="[
                                $v.form.isla_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Vol. Inicial:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.vol_inicial"
                              placeholder="73580.766 m³"
                              :class="[
                                $v.form.vol_inicial.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              @change="calcularVolCargado()"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <!-- <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Peso Inicial:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.peso_inicial"
                              placeholder="14418367 Kg"
                              :class="[
                                $v.form.peso_inicial.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="estado == 2"
                            />
                          </div>
                        </div> -->
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Volumen Cargado:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.vol_cargado"
                              placeholder="43m³"
                              :class="[
                                $v.form.vol_cargado.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Densidad:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.densidad"
                              placeholder="0,853"
                              :class="[
                                $v.form.densidad.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >T° de Carga:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.temperatura_carga"
                              placeholder="37,4°C"
                              :class="[
                                $v.form.temperatura_carga.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Instalación:</label
                          >
                          <div class="col-sm-8">
                            <select
                              v-model="form.instalacion"
                              class="form-control form-control-sm"
                              :class="[
                                $v.form.instalacion.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              @input="actualizarConsecutivoCarga()"
                              :disabled="camposBloqueados"
                            >
                              <option value="">Seleccione...</option>
                              <option
                                v-for="instalacion in listasForms.instalaciones"
                                :key="instalacion.numeracion"
                                :value="instalacion.numeracion"
                              >
                                {{ instalacion.descripcion }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >N° Pedido:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.numero_pedido"
                              placeholder="Ingrese el número de pedido..."
                              :disabled="camposBloqueados"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Hora Inicio:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.hora_inicio"
                              placeholder="15:08"
                              @change="valHoras()"
                              @input="sanitizarHora24h('hora_inicio')"
                              :class="[
                                $v.form.hora_inicio.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              v-mask="{
                                mask: '99:99',
                                hourFormat: '24',
                              }"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Hora Fin:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.hora_final"
                              placeholder="15:50"
                              @change="valHoras()"
                              @input="sanitizarHora24h('hora_final')"
                              :class="[
                                $v.form.hora_final.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              v-mask="{
                                mask: '99:99',
                                hourFormat: '24',
                              }"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Interno:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.numero_interno"
                              placeholder="193"
                              :class="[
                                $v.form.numero_interno.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              @blur="buscarCamionesInterno"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Cisterna:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <v-select
                              v-model="cisterna"
                              :options="listasForms.cisternas"
                              placeholder="Seleccione cisterna..."
                              label="placa"
                              :filterable="false"
                              class="form-control form-control-sm p-0 flex-grow-1"
                              @search="buscarCisternas"
                              @open="onCisternaOpen"
                              @input="selectCisterna()"
                              :class="[
                                $v.form.cisterna_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-info py-0 px-1 ml-2"
                              title="Ver datos de la cisterna"
                              data-toggle="modal"
                              data-target="#modal-datos-patente"
                              @click="setEntidadModalPatente('Cisterna')"
                              :disabled="form.cisterna_id"
                            >
                              <i class="fas fa-truck-loading fa-sm"></i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group row mb-2">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Líquido Cargado:</label
                          >
                          <div class="col-sm-8">
                            <select
                              v-model="form.producto_liquido_id"
                              class="form-control form-control-sm"
                              :class="[
                                $v.form.producto_liquido_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :disabled="camposBloqueados"
                            >
                              <option value="">Seleccione...</option>
                              <option value="1">Agua Producción</option>
                              <option value="2">Oil</option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Vol. Final:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.vol_final"
                              placeholder="73623.766 m³"
                              :class="[
                                $v.form.vol_final.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              @change="calcularVolCargado()"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div>
                        <!-- <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Peso Final:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.peso_final"
                              placeholder="14455040kg"
                              :class="[
                                $v.form.peso_final.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :readonly="camposBloqueados"
                            />
                          </div>
                        </div> -->
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Cliente:</label
                          >
                          <div class="col-sm-8">
                            <v-select
                              v-model="cliente"
                              :options="listasForms.clientes"
                              placeholder="Seleccione cliente..."
                              label="razon_social"
                              class="form-control form-control-sm p-0"
                              @search="buscarClientes"
                              @input="selectCliente()"
                              :class="[
                                $v.form.cliente_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Precinto Muestra/Guia:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.numero_muestra"
                              placeholder="Ingrese el número de muestra..."
                              :disabled="camposBloqueados"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Transporte:</label
                          >
                          <div class="col-sm-8">
                            <v-select
                              v-model="empresa"
                              :options="listasForms.empresas"
                              placeholder="Seleccione empresa..."
                              label="razon_social"
                              class="form-control form-control-sm p-0"
                              @search="buscarEmpresas"
                              @input="selectEmpresa()"
                              :class="[
                                $v.form.empresa_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              :disabled="camposBloqueados"
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Medidor:</label
                          >
                          <div class="col-sm-8">
                            <select
                              v-model="form.medidor"
                              class="form-control form-control-sm"
                              :class="[
                                $v.form.medidor.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                              :disabled="camposBloqueados"
                            >
                              <option value="">Seleccione...</option>
                              <option
                                v-for="medidor in listasForms.medidores"
                                :key="medidor.numeracion"
                                :value="medidor.numeracion"
                              >
                                {{ medidor.descripcion }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección LABORATORIO: título centrado, filas 2 columnas -->
                    <div class="border-top pt-3 mt-3">
                      <h6 class="text-center font-weight-bold mb-3">
                        LABORATORIO
                      </h6>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <div class="form-group row mb-0">
                            <label
                              class="col-sm-5 col-form-label col-form-label-sm"
                              >Densidad:</label
                            >
                            <div class="col-sm-7">
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="form.densidad_laboratorio"
                                placeholder="0,855"
                                :class="[
                                  $v.form.densidad_laboratorio.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid',
                                ]"
                                :readonly="camposBloqueados"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row mb-0">
                            <label
                              class="col-sm-6 col-form-label col-form-label-sm"
                              >% Agua + Sedimentos:</label
                            >
                            <div class="col-sm-6">
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="form.agua_laboratorio"
                                placeholder="0,05%"
                                :class="[
                                  $v.form.agua_laboratorio.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid',
                                ]"
                                :readonly="camposBloqueados"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <div class="form-group row mb-0">
                            <label
                              class="col-sm-5 col-form-label col-form-label-sm"
                              >Tº de muestra:</label
                            >
                            <div class="col-sm-7">
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="form.temperatura_laboratorio"
                                placeholder="33,1°C"
                                :class="[
                                  $v.form.temperatura_laboratorio.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid',
                                ]"
                                :readonly="camposBloqueados"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row mb-0">
                            <label
                              class="col-sm-5 col-form-label col-form-label-sm"
                              >Salinidad:</label
                            >
                            <div class="col-sm-7">
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="form.salinidad_laboratorio"
                                placeholder="102,54"
                                :class="[
                                  $v.form.salinidad_laboratorio.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid',
                                ]"
                                :readonly="camposBloqueados"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Precintos: dos líneas de entrada (como en la plantilla) -->
                    <div class="border-top pt-3 mt-3">
                      <label class="mb-2">Precintos:</label>
                      <div class="row">
                        <div class="col-md-12">
                          <v-select
                            ref="precintosSelect"
                            :class="[
                              $store.getters.getDarkMode ? 'dark-vselect' : '',
                              'form-control form-control-sm p-0',
                              precintos.length == 0 ? 'is-invalid' : 'is-valid',
                            ]"
                            v-model="precintos"
                            label="numero"
                            placeholder="Escriba el número del precinto y presione Enter"
                            taggable
                            push-tags
                            multiple
                            :disabled="camposBloqueados"
                            @input="validarPrecintoAlEscribir"
                          >
                            <template #selected-option="opt">
                              <span
                                class="d-inline-block"
                                :class="
                                  opt.sin_registro
                                    ? 'badge badge-warning text-dark'
                                    : 'badge badge-light text-dark border'
                                "
                                :title="
                                  opt.sin_registro
                                    ? 'Precinto no registrado en el sistema'
                                    : ''
                                "
                              >
                                {{
                                  opt.numero != null ? opt.numero : opt.label
                                }}
                              </span>
                            </template>
                          </v-select>
                          <!-- <v-select
                          v-model="precintos"
                          :options="opcionesPrecintosDisponibles"
                          placeholder="Seleccione precintos..."
                          label="numero"
                          :class="[
                            precintos.length == 0 ? 'is-invalid' : 'is-valid',
                            'form-control form-control-sm p-0',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          multiple
                          @search="searchPrecintos"
                          @input="selectPrecintos()"
                          :disabled="estado == 2"
                        ></v-select> -->
                        </div>
                      </div>
                    </div>

                    <div class="border-top pt-3 mt-3">
                      <label class="mb-2">Operario:</label>
                      <div class="row">
                        <div class="col-md-12">
                          <v-select
                            v-model="operario"
                            :options="listasForms.operarios"
                            placeholder="Seleccione operario..."
                            label="nOperario"
                            @search="buscarOperarios"
                            @input="selectOperario()"
                            class="form-control form-control-sm p-0"
                            :class="[
                              $v.form.operario_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                            :disabled="camposBloqueados"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="row justify-content-center">
                      <button
                        type="button"
                        class="btn btn-secondary mr-2"
                        @click="back()"
                      >
                        <i class="fas fa-reply"></i> Volver
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="save()"
                        v-if="
                          $store.getters.can('argentina.hojasCarga.save') &&
                            !$v.form.$invalid &&
                            precintos.length > 0
                        "
                        :disabled="camposBloqueados"
                      >
                        <i class="fas fa-save"></i> Guardar
                      </button>
                      <button
                        type="button"
                        class="btn btn-success ml-2"
                        @click="AgregarNumeroHojaCarga()"
                        v-if="
                          form.id &&
                            $store.getters.can(
                              'argentina.hojasCarga.envioWhatsapp',
                            )
                        "
                      >
                        <i class="fab fa-whatsapp"></i> Enviar Hoja de Carga
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger ml-2"
                        @click="printPDF(form.id)"
                        v-if="form.id"
                      >
                        <i class="fas fa-file-pdf"></i> PDF Hoja de Carga
                      </button>
                      <button
                        type="button"
                        class="btn btn-success ml-2"
                        @click="AgregarNumeroRemito()"
                        v-if="
                          form.id &&
                            $store.getters.can(
                              'argentina.hojasCarga.envioWhatsapp',
                            )
                        "
                      >
                        <i class="fab fa-whatsapp"></i> Enviar Remito
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger ml-2"
                        @click="generarPDFRemito()"
                        v-if="form.id"
                      >
                        <i class="fas fa-file-pdf"></i> PDF Remito
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ModalDatosPatente ref="modalDatosPatente" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
import ModalDatosPatente from "./ModalDatosPatente";

export default {
  name: "HojaCargaForm",
  components: {
    Loading,
    vSelect,
    ModalDatosPatente,
  },

  validations() {
    let volIni = {};
    let volFin = {};
    let mMedidor = {};
    let dDensidad = {};
    let tTemperatura = {};
    let lDensidad = {};
    let lTemperatura = {};
    let lAgua = {};
    let lSalinidad = {};

    if (this.form.producto_liquido_id) {
      if (this.form.producto_liquido_id == 2) {
        if (this.form.instalacion == 2) {
          volIni = {
            required: false,
          };
          volFin = {
            required: false,
          };
        } else {
          volIni = {
            required,
          };
          volFin = {
            required,
          };
        }
        mMedidor = {
          required,
        };
        dDensidad = {
          required,
        };
        tTemperatura = {
          required,
        };
        lDensidad = {
          required,
        };
        lTemperatura = {
          required,
        };
        lAgua = {
          required,
        };
        lSalinidad = {
          required,
        };
      } else {
        volIni = {
          required: false,
        };
        volFin = {
          required: false,
        };
        mMedidor = {
          required: false,
        };
        dDensidad = {
          required: false,
        };
        tTemperatura = {
          required: false,
        };
        lDensidad = {
          required: false,
        };
        lTemperatura = {
          required: false,
        };
        lAgua = {
          required: false,
        };
        lSalinidad = {
          required: false,
        };
      }
    }

    return {
      form: {
        operario_id: {
          required,
        },
        remito_id: {
          required,
        },
        isla_id: {
          required,
        },
        chofer_id: {
          required,
        },
        camion_id: {
          required,
        },
        vol_inicial: volIni,
        vol_cargado: {
          required,
        },
        densidad: dDensidad,
        temperatura_carga: tTemperatura,
        hora_inicio: {
          required,
        },
        hora_final: {
          required,
        },
        numero_interno: {
          required,
        },
        cisterna_id: {
          required,
        },
        producto_liquido_id: {
          required,
        },
        vol_final: volFin,
        cliente_id: {
          required,
        },
        empresa_id: {
          required,
        },
        densidad_laboratorio: lDensidad,
        temperatura_laboratorio: lTemperatura,
        agua_laboratorio: lAgua,
        salinidad_laboratorio: lSalinidad,
        fecha: {
          required,
        },
        instalacion: {
          required,
        },
        medidor: mMedidor,
      },
    };
  },
  data() {
    return {
      cargando: false,
      id: null,
      metodo: null,
      accion: null,
      camion: {},
      cisterna: {},
      chofer: {},
      isla: {},
      cliente: {},
      empresa: {},
      remito: {},
      producto_liquido: {},
      operario: {},
      precintos: [],
      estado: null,
      user: {},
      instalacionesTodas: [],
      listasForms: {
        islas: [],
        camiones: [],
        cisternas: [],
        choferes: [],
        clientes: [],
        empresas: [],
        operarios: [],
        precintos: [],
        medidores: [],
        instalaciones: [],
        productos_liquidos: [],
      },
      form: {
        operario_id: null,
        nombre_isla: null,
        numero_chofer: null,
        remito_id: null,
        isla_id: null,
        chofer_id: null,
        camion_id: null,
        vol_inicial: null,
        peso_inicial: null,
        vol_cargado: null,
        densidad: null,
        temperatura_carga: null,
        fecha: null,
        hora_inicio: null,
        hora_final: null,
        numero_interno: null,
        cisterna_id: null,
        producto_liquido_id: null,
        vol_final: null,
        peso_final: null,
        cliente_id: null,
        numero_carga: null,
        empresa_id: null,
        densidad_laboratorio: null,
        temperatura_laboratorio: null,
        agua_laboratorio: null,
        salinidad_laboratorio: null,
        precintos: [],
        instalacion: null,
        medidor: null,
      },
    };
  },
  computed: {
    opcionesPrecintosDisponibles() {
      const idsSeleccionados = (this.precintos || []).map(
        (p) => p.id ?? p.numero,
      );
      return (this.listasForms.precintos || []).filter(
        (p) => !idsSeleccionados.includes(p.id ?? p.numero),
      );
    },
    /** Estado 3: solo lectura. Estado 2: editable solo con permiso cambiarCampos. */
    camposBloqueados() {
      if (
        this.estado == 2 &&
        !this.$store.getters.can("argentina.hojasCarga.cambiarCampos")
      ) {
        return true;
      }
      if (this.estado == 3) {
        return true;
      }
      return false;
    },
  },
  methods: {
    init() {
      this.accion = this.$route.params.accion;
      this.user = this.$store.state.user;
      this.id = this.$route.params.id;
      if (this.accion === "Editar" && this.id) {
        this.metodo = "PUT";
        this.show();
      } else {
        this.metodo = "POST";
        this.form.fecha = moment().format("YYYY-MM-DD");
        this.form.hora_inicio = moment().format("HH:mm");
        this.searchRemito();
      }
    },

    show() {
      this.cargando = true;
      let me = this;
      axios
        .get("/api/argentina/hojasCarga/show/" + this.id)
        .then((response) => {
          me.getData(response.data);
          me.cargando = false;
        })
        .catch((error) => {
          me.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getData(hojaCarga) {
      this.form = hojaCarga;
      this.form.numero_chofer = hojaCarga.chofer.numero_documento;
      this.form.nombre_isla = hojaCarga.isla.bloque?.nombre || "Sin Bloque";
      this.chofer = hojaCarga.chofer;
      this.camion = hojaCarga.camion;
      this.cisterna = hojaCarga.cisterna;
      this.operario = hojaCarga.operario;
      //this.producto_liquido = hojaCarga.producto_liquido;
      this.chofer = hojaCarga.chofer;
      this.isla = hojaCarga.isla;
      this.cliente = hojaCarga.cliente;
      this.empresa = hojaCarga.empresa;
      this.remito = hojaCarga.remito;
      const precArg = hojaCarga.precintos || [];
      const dedupCarga = this.dedupePrecintosArray(precArg);
      this.precintos = dedupCarga.lista;
      this.selectPrecintos();
      this.estado = hojaCarga.estado;
      this.sincronizarCisternasDesdeCamion();
      this.filtrarInstalacionesPorIsla();
    },

    save() {
      let self = this;
      self.cargando = true;
      axios({
        method: this.metodo,
        url: "/api/argentina/hojasCarga",
        data: self.form,
      })
        .then(async (response) => {
          self.cargando = false;
          this.$route.params.accion = "Editar";
          this.$route.params.id = response.data.id;
          this.init();
          this.$swal({
            icon: "success",
            title: "La hoja de carga se guardo exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          self.cargando = false;
          let res = Object.assign({}, e);
          this.$swal({
            icon: "error",
            title:
              "Ocurrio un error, vuelva a intentarlo..." +
              res.response.data.message,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    back() {
      return this.$router.replace("/Argentina/Operacion/HojasCarga");
    },

    getMedidores() {
      let me = this;
      axios.get("/api/lista/232").then((response) => {
        me.listasForms.medidores = response.data;
      });
    },

    getInstalaciones() {
      let me = this;
      axios.get("/api/lista/231").then((response) => {
        me.instalacionesTodas = response.data || [];
        me.filtrarInstalacionesPorIsla();
      });
    },

    filtrarInstalacionesPorIsla() {
      const todas = this.instalacionesTodas || [];
      const islaInstalaciones = (this.isla && this.isla.instalaciones) || [];

      this.listasForms.instalaciones = islaInstalaciones.length
        ? todas.filter((i) =>
            islaInstalaciones.some(
              (instalacion) =>
                Number(instalacion.numeracion) === Number(i.numeracion),
            ),
          )
        : [...todas];
    },

    buscarCamiones(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/camiones/lista?placa=" + search;
        axios
          .get(url)
          .then((response) => {
            self.listasForms.camiones = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarCamionesInterno() {
      let me = this;
      var url =
        "/api/argentina/camiones/lista?numero_interno=" +
        this.form.numero_interno;
      axios
        .get(url)
        .then((response) => {
          me.camion = response.data[0];
          me.selectCamionInterno();
        })
        .catch((error) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    onCisternaOpen() {
      this.buscarCisternas("", () => {});
    },

    /** Rellena el desplegable con las cisternas ya traídas en el camión (patentes). */
    sincronizarCisternasDesdeCamion() {
      if (!this.camion?.patentes_cliente?.length) return;
      const porId = new Map();
      for (const p of this.camion.patentes_cliente) {
        const c = p.pivot?.cisterna;
        if (c && c.id) porId.set(c.id, c);
      }
      if (porId.size) {
        this.listasForms.cisternas = Array.from(porId.values());
      }
    },

    buscarCisternas(search, loading) {
      const loadingFn = typeof loading === "function" ? loading : () => {};
      const self = this;
      const placa = (search != null ? String(search) : "").trim();
      loadingFn(true);
      const url =
        "/api/argentina/trailers/lista?placa=" + encodeURIComponent(placa);
      axios
        .get(url)
        .then((response) => {
          self.listasForms.cisternas = response.data || [];
          loadingFn(false);
        })
        .catch((error) => {
          self.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          loadingFn(false);
        });
    },

    buscarChoferes(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/choferes/lista?nombre=" + search;
        axios
          .get(url)
          .then((response) => {
            self.listasForms.choferes = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarIslas(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/sitios/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.listasForms.islas = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    /* buscarProductoLiquido(search) {
      if (search != "") {
        let me = this;
        var url = "/api/hidrocarburos/Productos/lista?nombre=" + search;
        axios
          .get(url)
          .then((response) => {
            me.listasForms.productos_liquidos = response.data;
          })
          .catch((error) => {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    }, */

    buscarClientes(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/clientes/lista?razon_social=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.listasForms.clientes = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarOperarios(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/operarios/lista?nombres=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.listasForms.operarios = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/empresas/lista?razon_social=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.listasForms.empresas = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    searchRemito() {
      let me = this;
      me.cargando = true;
      let url = "/api/argentina/hojasCarga/searchRemito";
      axios
        .get(url, {
          params: {
            remito_numero: me.remito?.numero,
            sitios_ids: me.$store.state.user.sitios.map((s) => s.id),
          },
        })
        .then((response) => {
          let respuesta = response.data;
          me.remito = respuesta;
          me.cargando = false;
          me.selectRemito();
          me.$swal({
            icon: !respuesta.msg ? "success" : "error",
            title: respuesta.msg || "Remito encontrado",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    normalizarClavePrecinto(p) {
      if (p == null) return null;
      if (typeof p === "string") {
        const s = String(p)
          .trim()
          .toLowerCase();
        return s ? `n:${s}` : null;
      }
      if (typeof p === "object") {
        if (p.id != null && p.id !== "") return `id:${p.id}`;
        const s = String(p.numero != null ? p.numero : "")
          .trim()
          .toLowerCase();
        return s ? `n:${s}` : null;
      }
      return null;
    },

    dedupePrecintosArray(arr) {
      const seen = new Set();
      const lista = [];
      let duplicados = 0;
      for (const p of arr || []) {
        const k = this.normalizarClavePrecinto(p);
        if (!k) {
          lista.push(p);
          continue;
        }
        if (seen.has(k)) {
          duplicados++;
          continue;
        }
        seen.add(k);
        lista.push(p);
      }
      return { lista, duplicados };
    },

    limpiarListaYBusquedaPrecintos() {
      this.listasForms.precintos = [];
      this.$nextTick(() => {
        const vs = this.$refs.precintosSelect;
        if (!vs) return;
        if (typeof vs.search === "string") vs.search = "";
        else if (vs.$data && typeof vs.$data.search === "string") {
          vs.$data.search = "";
        }
      });
    },

    validarPrecintoAlEscribir(nuevoValor) {
      const me = this;
      let arr = nuevoValor || [];

      const { lista: sinDuplicados, duplicados } = this.dedupePrecintosArray(
        arr,
      );
      if (duplicados > 0) {
        this.precintos = sinDuplicados;
        this.$swal({
          icon: "warning",
          title: "No puede repetir el mismo precinto.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.$nextTick(() => {
          this.selectPrecintos();
          this.limpiarListaYBusquedaPrecintos();
        });
        return;
      }
      arr = sinDuplicados;

      const pendienteApi = arr.find((p) => {
        if (p && typeof p === "object" && p.sin_registro) return false;
        return (
          typeof p === "string" ||
          (p && typeof p === "object" && (p.id == null || p.id === ""))
        );
      });

      if (!pendienteApi) {
        this.$nextTick(() => {
          this.selectPrecintos();
          this.limpiarListaYBusquedaPrecintos();
        });
        return;
      }

      const numero =
        typeof pendienteApi === "string"
          ? pendienteApi
          : pendienteApi.numero || "";
      if (!String(numero).trim() || me.form.numero_interno == "") return;

      const numeroTrim = String(numero).trim();
      const url = "/api/argentina/hojasCarga/searchPrecintos";
      axios
        .get(url, { params: { numero: numeroTrim } })
        .then((response) => {
          const data = response.data || {};
          const encontrado = data.id ? data : null;
          const copia = [...(me.precintos || [])];
          const idx = copia.findIndex((p) => {
            const n =
              typeof p === "string"
                ? p
                : (p && p.numero) != null
                ? p.numero
                : "";
            return String(n).trim() === numeroTrim;
          });
          if (idx === -1) return;
          if (encontrado) {
            copia[idx] = encontrado;
            me.precintos = copia;
            me.selectPrecintos();
            me.limpiarListaYBusquedaPrecintos();
          } else {
            copia[idx] = {
              id: null,
              numero: numeroTrim,
              sin_registro: true,
            };
            me.precintos = copia;
            me.selectPrecintos();
            me.limpiarListaYBusquedaPrecintos();
            me.$swal({
              icon: "info",
              title:
                'El precinto "' +
                numeroTrim +
                '" no está registrado. Se guardará igualmente.',
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          }
        })
        .catch(() => {
          const copia = [...(me.precintos || [])];
          const idx = copia.findIndex((p) => {
            const n =
              typeof p === "string"
                ? p
                : (p && p.numero) != null
                ? p.numero
                : "";
            return String(n).trim() === numeroTrim;
          });
          if (idx !== -1) {
            copia[idx] = {
              id: null,
              numero: numeroTrim,
              sin_registro: true,
            };
            me.precintos = copia;
            me.selectPrecintos();
            me.limpiarListaYBusquedaPrecintos();
          }
          me.$swal({
            icon: "warning",
            title:
              "No se pudo validar el precinto. Se dejó como no registrado.",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    searchAntHoja() {
      let me = this;
      me.cargando = true;
      let url = "/api/argentina/hojasCarga/searchAntHoja";
      axios
        .get(url, {
          params: {
            isla_id: me.form.isla_id,
          },
        })
        .then((response) => {
          let respuesta = response.data;
          me.antHoja = respuesta;
          me.form.vol_inicial = me.antHoja.vol_final;
          me.$swal({
            icon: !respuesta.msg ? "success" : "error",
            title: respuesta.msg || "Volumen inicial cargado",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        })
        .catch((error) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    setEntidadModalPatente(entidad) {
      const modal = this.$refs.modalDatosPatente;
      if (modal && modal.entidad !== undefined) {
        modal.limpiarForm();
        modal.entidad = entidad;
      }
    },

    selectChofer() {
      this.form.chofer_id = null;
      this.form.numero_chofer = null;
      if (this.chofer) {
        this.form.chofer_id = this.chofer.id;
        this.form.numero_chofer = this.chofer.numero_documento;
      }
    },

    selectCamion() {
      this.form.camion_id = null;
      if (this.camion) {
        this.form.camion_id = this.camion.id;
        this.form.numero_interno = this.camion.numero_interno;
        if (
          this.camion.patentes_cliente &&
          this.camion.patentes_cliente.length > 0
        ) {
          this.form.cisterna_id =
            this.camion.patentes_cliente[0].pivot.cisterna_id || null;
          this.form.cliente_id =
            this.camion.patentes_cliente[0].pivot.cliente_id || null;
          this.form.empresa_id =
            this.camion.patentes_cliente[0].pivot.empresa_id || null;
          this.cisterna = this.camion.patentes_cliente[0].pivot.cisterna || {};
          this.cliente = this.camion.patentes_cliente[0] || {};
          this.empresa = this.camion.patentes_cliente[0].pivot.empresa || {};
        }
        this.sincronizarCisternasDesdeCamion();
      }
    },

    selectCamionInterno() {
      this.form.camion_id = null;
      this.form.cisterna_id = null;
      this.form.cliente_id = null;
      this.form.empresa_id = null;
      this.cisterna = {};
      this.cliente = {};
      this.empresa = {};

      if (this.camion) {
        this.form.camion_id = this.camion.id;
        if (
          this.camion.patentes_cliente &&
          this.camion.patentes_cliente.length > 0
        ) {
          this.form.cisterna_id =
            this.camion.patentes_cliente[0].pivot.cisterna_id || null;
          this.form.cliente_id =
            this.camion.patentes_cliente[0].pivot.cliente_id || null;
          this.form.empresa_id =
            this.camion.patentes_cliente[0].pivot.empresa_id || null;
          this.cisterna = this.camion.patentes_cliente[0].pivot.cisterna || {};
          this.cliente = this.camion.patentes_cliente[0] || {};
          this.empresa = this.camion.patentes_cliente[0].pivot.empresa || {};
        }
        this.sincronizarCisternasDesdeCamion();
      }
    },

    selectCisterna() {
      this.form.cisterna_id = null;
      if (this.cisterna) {
        this.form.cisterna_id = this.cisterna.id;
      }
    },

    selectOperario() {
      this.form.operario_id = null;
      if (this.operario) {
        this.form.operario_id = this.operario.id;
      }
    },

    /* selectProductoLiquido() {
      this.form.producto_liquido_id = null;
      if (this.producto_liquido) {
        this.form.producto_liquido_id = this.producto_liquido.id;
      }
    }, */

    selectIsla() {
      this.form.isla_id = null;
      this.form.nombre_isla = null;
      this.form.instalacion = null;

      if (this.isla) {
        this.form.isla_id = this.isla.id;
        this.form.nombre_isla = this.isla.bloque?.nombre || "Sin Bloque";
        this.filtrarInstalacionesPorIsla();

        if (this.form.isla_id == 143) {
          this.form.instalacion = 2;
        } else {
          this.searchAntHoja();
        }
      } else {
        this.listasForms.instalaciones = [...this.instalacionesTodas];
      }
    },

    selectCliente() {
      this.form.cliente_id = null;
      if (this.cliente) {
        this.form.cliente_id = this.cliente.id;
        this.actualizarConsecutivoCarga();
      }
    },

    selectEmpresa() {
      this.form.empresa_id = null;
      if (this.empresa) {
        this.form.empresa_id = this.empresa.id;
      }
    },

    selectRemito() {
      this.form.remito_id = null;
      if (this.remito) {
        this.form.remito_id = this.remito.id;
      }
    },

    selectPrecintos() {
      if (!this.precintos.length) {
        this.form.precintos = [];
        return;
      }
      this.form.precintos = this.precintos.map((p) => {
        if (typeof p === "string") {
          return { numero: String(p).trim(), sin_registro: true };
        }
        if (p.sin_registro || p.id == null) {
          return {
            numero: String(p.numero != null ? p.numero : "").trim(),
            sin_registro: true,
          };
        }
        return p.id;
      });
    },

    valHoras() {
      if (this.form.hora_inicio && this.form.hora_final) {
        let horaInicio = moment(this.form.hora_inicio, "HH:mm");
        let horaFin = moment(this.form.hora_final, "HH:mm");
        let diferencia = horaFin.diff(horaInicio, "hours");
        if (diferencia < 0) {
          this.$swal({
            icon: "warning",
            title: "Aviso de horarios",
            html: `<p style="font-size: 0.875rem; line-height: 1.5; margin: 0.5rem 0 0; color: #4a5568; text-align: center;">
              La hora de finalización no puede ser anterior a la hora de inicio. En caso de que la hora final sea menor, se asumirá que corresponde al día siguiente.
            </p>`,
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          //this.form.hora_final = null;
        }
      }
    },

    AgregarNumeroHojaCarga() {
      const viaje = this.form;
      this.$swal({
        title: "Agregar número celular para la hoja de carga",
        html: `
          <div style="text-align: left; margin-bottom: 20px;">
            <p><strong>Remito:</strong> ${viaje.remito.digito_verificacion} - ${viaje.remito.numero}</p>
            <p><strong>Chofer:</strong> ${viaje.chofer.nombre}</p>
            <p><strong>Camion:</strong> ${viaje.camion.placa}</p>
            <p><strong>Cisterna:</strong> ${viaje.cisterna.placa}</p>
            <p><strong>Cliente:</strong> ${viaje.cliente.razon_social}</p>
            <p><strong>Empresa:</strong> ${viaje.empresa.razon_social}</p>
          </div>
          <div style="margin-top: 20px;">
            <label for="numeroChoferHc" style="display: block; margin-bottom: 8px; font-weight: bold;">Número celular:</label>
            <input
              type="number"
              id="numeroChoferHc"
              class="swal2-input"
              placeholder="Número celular"
              min="1"
              required
              style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px;"
            />
          </div>
        `,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Agregar Número Celular",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          // Esperar un poco para que SweetAlert2 termine de renderizar
          setTimeout(() => {
            const input = document.getElementById("numeroChoferHc");
            const confirmButton = document.querySelector(".swal2-confirm");

            if (input && confirmButton) {
              // Ocultar el botón inicialmente
              confirmButton.style.visibility = "hidden";
              confirmButton.style.opacity = "0";
              confirmButton.disabled = true;

              // Función para verificar el input
              const checkInput = () => {
                const value = input.value.trim();
                if (value && parseInt(value) > 0) {
                  confirmButton.style.visibility = "visible";
                  confirmButton.style.opacity = "1";
                  confirmButton.disabled = false;
                } else {
                  confirmButton.style.visibility = "hidden";
                  confirmButton.style.opacity = "0";
                  confirmButton.disabled = true;
                }
              };

              // Verificar en tiempo real
              input.addEventListener("input", checkInput);
              input.addEventListener("keyup", checkInput);
              input.addEventListener("paste", () => {
                setTimeout(checkInput, 10);
              });
            }
          }, 200);
        },
        preConfirm: () => {
          const numeroCelular = document.getElementById("numeroChoferHc").value;

          if (!numeroCelular || numeroCelular.trim() === "") {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "Por favor ingrese un número celular válido",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          if (parseInt(numeroCelular) <= 0) {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "El número celular debe ser mayor a 0",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          return numeroCelular;
        },
      }).then((result) => {
        if (result.value) {
          const numeroCelular = result.value;
          // Confirmación final
          this.$swal({
            title: "¿Confirmar creación?",
            text: `¿Está seguro de enviar la hoja de carga con el número celular "${numeroCelular}" ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Enviar!",
            cancelButtonText: "Cancelar",
          }).then((confirmResult) => {
            if (confirmResult.value) {
              // Aquí puedes enviar los datos al backend
              this.enviarWhatsApp(numeroCelular);
            }
          });
        }
      });
    },

    enviarWhatsApp(numeroCelular) {
      let me = this;
      me.cargando = true;
      let url = "/api/argentina/hojasCarga/enviarWhatsApp/" + me.id;
      axios
        .get(url, {
          params: {
            numero_celular: numeroCelular,
          },
        })
        .then((response) => {
          me.$swal({
            icon: "success",
            title: "WhatsApp enviado exitosamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        })
        .catch((error) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    async generarRemito(resultado) {
      try {
        this.cargando = true;

        // Llamar al backend para generar el PDF
        const response = await axios.post(
          "/api/argentina/control-cargues/generar-remito",
          resultado,
          {
            responseType: "blob", // Importante para recibir el PDF
          },
        );

        // Crear un link para descargar el PDF
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo con fecha y remito
        const nombreArchivo = `Remito_${
          resultado.remito ? resultado.remito.numero_formateado : "SN"
        }_${resultado.fecha}.pdf`;
        link.setAttribute("download", nombreArchivo);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$swal({
          icon: "success",
          title: "Remito generado exitosamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } catch (error) {
        console.error("Error al generar remito:", error);
        this.$swal({
          icon: "error",
          title: "Error al generar el remito",
          text: error.response?.data?.message || "Intente nuevamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    generarPDFRemito() {
      let me = this;
      me.cargando = true;
      axios
        .get("/api/argentina/hojasCarga/pdfRemito/" + me.id)
        .then((response) => {
          let data = response.data;
          window.open(data.url, "_blank");
          me.cargando = false;
        })
        .catch((e) => {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    printPDF(hoja_id) {
      axios
        .get("/api/argentina/hojasCarga/pdf/" + hoja_id)
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    AgregarNumeroRemito() {
      const viaje = this.form;
      this.$swal({
        title: "Agregar número celular para el remito",
        html: `
          <div style="text-align: left; margin-bottom: 20px;">
            <p><strong>Remito:</strong> ${viaje.remito.digito_verificacion} - ${viaje.remito.numero}</p>
            <p><strong>Chofer:</strong> ${viaje.chofer.nombre}</p>
            <p><strong>Camion:</strong> ${viaje.camion.placa}</p>
            <p><strong>Cisterna:</strong> ${viaje.cisterna.placa}</p>
            <p><strong>Cliente:</strong> ${viaje.cliente.razon_social}</p>
            <p><strong>Empresa:</strong> ${viaje.empresa.razon_social}</p>
          </div>
          <div style="margin-top: 20px;">
            <label for="numeroRemito" style="display: block; margin-bottom: 8px; font-weight: bold;">Número celular:</label>
            <input
              type="number"
              id="numeroRemito"
              class="swal2-input"
              placeholder="Número celular"
              min="1"
              required
              style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px;"
            />
          </div>
        `,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Agregar Número Celular",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          // Esperar un poco para que SweetAlert2 termine de renderizar
          setTimeout(() => {
            const input = document.getElementById("numeroRemito");
            const confirmButton = document.querySelector(".swal2-confirm");

            if (input && confirmButton) {
              // Ocultar el botón inicialmente
              confirmButton.style.visibility = "hidden";
              confirmButton.style.opacity = "0";
              confirmButton.disabled = true;

              // Función para verificar el input
              const checkInput = () => {
                const value = input.value.trim();
                if (value && parseInt(value) > 0) {
                  confirmButton.style.visibility = "visible";
                  confirmButton.style.opacity = "1";
                  confirmButton.disabled = false;
                } else {
                  confirmButton.style.visibility = "hidden";
                  confirmButton.style.opacity = "0";
                  confirmButton.disabled = true;
                }
              };

              // Verificar en tiempo real
              input.addEventListener("input", checkInput);
              input.addEventListener("keyup", checkInput);
              input.addEventListener("paste", () => {
                setTimeout(checkInput, 10);
              });
            }
          }, 200);
        },
        preConfirm: () => {
          const numeroCelular = document.getElementById("numeroRemito").value;

          if (!numeroCelular || numeroCelular.trim() === "") {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "Por favor ingrese un número celular válido",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          if (parseInt(numeroCelular) <= 0) {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "El número celular debe ser mayor a 0",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          return numeroCelular;
        },
      }).then((result) => {
        if (result.value) {
          const numeroCelular = result.value;
          // Confirmación final
          this.$swal({
            title: "¿Confirmar creación?",
            text: `¿Está seguro de enviar el remito con el número celular "${numeroCelular}" ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Enviar!",
            cancelButtonText: "Cancelar",
          }).then((confirmResult) => {
            if (confirmResult.value) {
              // Aquí puedes enviar los datos al backend
              this.enviarWhatsAppRemito(numeroCelular);
            }
          });
        }
      });
    },

    enviarWhatsAppRemito(numeroCelular) {
      let me = this;
      me.cargando = true;
      axios
        .get("/api/argentina/hojasCarga/enviarWhatsAppRemito/" + me.id, {
          params: {
            numero_celular: numeroCelular,
          },
        })
        .then((response) => {
          let data = response.data;
          me.cargando = false;
          me.$swal({
            icon: data.success == true ? "success" : "error",
            title: data.message,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    calcularVolCargado() {
      if (this.form.vol_final && this.form.vol_inicial) {
        this.form.vol_cargado = this.form.vol_final - this.form.vol_inicial;
        this.form.vol_cargado = this.form.vol_cargado.toFixed(3);
      }
    },

    sanitizarHora24h(campo) {
      this.$nextTick(() => {
        const raw = this.form[campo];
        if (raw == null || raw === "") return;
        const flat = String(raw).replace(/\D/g, "");
        if (flat.length < 2) return;
        const h0 = parseInt(flat.slice(0, 2), 10);
        const h = Math.min(23, Math.max(0, h0));
        const rest = flat.slice(2);
        if (rest.length < 2) {
          if (h0 === h) return;
          this.form[campo] = rest.length
            ? `${String(h).padStart(2, "0")}:${rest}`
            : `${String(h).padStart(2, "0")}:`;
          return;
        }
        const m0 = parseInt(rest.slice(0, 2), 10);
        const m = Math.min(59, Math.max(0, m0));
        if (h0 === h && m0 === m) return;
        this.form[campo] = `${String(h).padStart(2, "0")}:${String(m).padStart(
          2,
          "0",
        )}`;
      });
    },

    actualizarConsecutivoCarga() {
      if (this.form.cliente_id && this.form.instalacion) {
        this.form.numero_carga = null;
        let clienteInstalacion = this.cliente.cliente_instalaciones.filter(
          (i) =>
            i.pivot.instalacion === this.form.instalacion &&
            i.pivot.cliente_id === this.form.cliente_id,
        )[0];

        this.form.numero_carga = this.cliente.cliente_instalaciones.find(
          (i) => i.numeracion === this.form.instalacion,
        ).pivot.consecutivo_actual
          ? this.cliente.cliente_instalaciones.find(
              (i) => i.numeracion === this.form.instalacion,
            ).pivot.consecutivo_actual + 1
          : this.cliente.cliente_instalaciones.find(
              (i) => i.numeracion === this.form.instalacion,
            ).pivot.consecutivo_carga
          ? this.cliente.cliente_instalaciones.find(
              (i) => i.numeracion === this.form.instalacion,
            ).pivot.consecutivo_carga + 1
          : null;
      }
    },
  },
  mounted() {
    this.init();
    this.getMedidores();
    this.getInstalaciones();
  },
};
</script>
